import type {
  ContentfulCallToActionType,
  ContentfulFileType,
  ContentfulImageLinkGalleryType,
  ContentfulImageLinkType,
  ParsedContentNode,
} from '@/types';
import React, { FC } from 'react';
import { Image } from './image';
import { Cta } from './cta';
import { ImageLink } from './image-link';
import { ImageLinkGallery } from './image-link-gallery';

interface Props {
  content: ParsedContentNode[];
  className?: string;
  style?: React.CSSProperties;
}

export const ContentManager: FC<Props> = ({ content, className, style }) => {
  return (
    <div className={`contentManager${className ? ' ' + className : ''}`}>
      {content &&
        content.map((item, index) => {
          switch (item.type) {
            case 'embedded-asset-block': {
              const file = item.data as ContentfulFileType;
              return (
                <div
                  key={index}
                  className="contentManager--image-wrapper"
                  style={style}
                >
                  <Image
                    src={item.data}
                    alt={file.title}
                    className="contentManager--image"
                    animateInView
                  />
                </div>
              );
            }
            case 'callToAction': {
              const cta = item.data as ContentfulCallToActionType;
              if (cta) {
                return (
                  <Cta
                    key={index}
                    cta={cta}
                    theme="light"
                    className="contentManager--cta"
                  />
                );
              }
            }
            case 'imageLink': {
              const data = item.data as ContentfulImageLinkType;
              return <ImageLink {...data} key={index} />;
            }
            case 'imageLinkGallery': {
              const data = item.data as ContentfulImageLinkGalleryType;
              return <ImageLinkGallery gallery={data.gallery} key={index} />;
            }
            default: {
              return item.html ? (
                <div
                  key={index}
                  className={item.type}
                  dangerouslySetInnerHTML={{
                    __html: item.html.replace(/\n/g, '<br>').replace(/<a /g, '<a target="_blank" '),
                  }}
                  style={style}
                />
              ) : (
                <div
                  className={item.type}
                  data-type={
                    process.env.NODE_ENV === 'development' && item.type
                  }
                  key={index}
                  style={style}
                />
              );
            }
          }
        })}
    </div>
  );
};
